import React, { useState, useEffect } from 'react';
import { FaGift, FaStar, FaShieldAlt, FaExclamationTriangle } from 'react-icons/fa';
import PartnersList from '../../components/PartnersList';
import PageHeader from '../../components/PageHeader/PageHeader';
import './ParceriasPage.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

function ParceriasPage() {
  const [partners, setPartners] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const response = await fetch(`${API_URL}/partners/`);
        const data = await response.json();
        setPartners(data.results || data);
      } catch (error) {
        console.error('Erro ao carregar parceiros:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPartners();
  }, []);

  const features = [
    { icon: <FaGift />, title: 'Benefícios Exclusivos', desc: 'Códigos e bónus especiais' },
    { icon: <FaStar />, title: 'Parceiros Verificados', desc: 'Plataformas de confiança' },
    { icon: <FaShieldAlt />, title: 'Segurança', desc: 'Sites seguros e legítimos' },
  ];

  return (
    <main className="page-container parcerias-page">
      <PageHeader
        eyebrow="Parcerias"
        title="Parcerias Oficiais"
        subtitle="Códigos e bónus exclusivos nas plataformas com que trabalhamos."
      />

      <div className="parcerias-features">
        {features.map((feature, index) => (
          <div key={index} className="parcerias-feature-card">
            <div className="feature-icon">{feature.icon}</div>
            <div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-desc">{feature.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <h2 className="section-title">Parceiros</h2>
      {isLoading ? (
        <div className="loading-state">A carregar parceiros…</div>
      ) : (
        <PartnersList partners={partners} />
      )}

      <p className="parcerias-disclaimer">
        <FaExclamationTriangle aria-hidden="true" />
        <span>Alguns parceiros contêm conteúdo +18. Joga com responsabilidade.</span>
      </p>
    </main>
  );
}

export default ParceriasPage;
